import api from './api'

class PrePaymentService {
  // Get all pre-payments
  async getAllPrePayments(params = {}) {
    try {
      const response = await api.get('/hr/pre-payments', { params })
      console.log('Raw Pre-Payments API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      const prePayments = data.prePayments || data || []
      
      return {
        success: true,
        data: prePayments,
        totalResults: data.totalResults || prePayments.length,
        message: response.data.message || 'Pre-payments retrieved successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to retrieve pre-payments',
        error: error.response?.data
      }
    }
  }

  // Get pre-payment by ID
  async getPrePaymentById(prePaymentId) {
    try {
      const response = await api.get(`/hr/pre-payments/${prePaymentId}`)
      console.log('Raw Pre-Payment by ID API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.prePayment || data,
        message: response.data.message || 'Pre-payment retrieved successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to retrieve pre-payment',
        error: error.response?.data
      }
    }
  }

  // Create new pre-payment
  async createPrePayment(prePaymentData) {
    try {
      const response = await api.post('/hr/pre-payments', prePaymentData)
      console.log('Raw Pre-Payment POST API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.prePayment || data,
        message: response.data.message || 'Pre-payment created successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create pre-payment',
        error: error.response?.data
      }
    }
  }

  // Update pre-payment
  async updatePrePayment(prePaymentId, prePaymentData) {
    try {
      const response = await api.patch(`/hr/pre-payments/${prePaymentId}`, prePaymentData)
      console.log('Raw Pre-Payment PATCH API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.prePayment || data,
        message: response.data.message || 'Pre-payment updated successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update pre-payment',
        error: error.response?.data
      }
    }
  }

  // Delete pre-payment
  async deletePrePayment(prePaymentId) {
    try {
      const response = await api.delete(`/hr/pre-payments/${prePaymentId}`)
      return {
        success: true,
        message: response.data.message || 'Pre-payment deleted successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete pre-payment',
        error: error.response?.data
      }
    }
  }
}

const prePaymentService = new PrePaymentService()
export default prePaymentService
